'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {Routes} from '../../config/routes'
import theme from '../../config/theme'

import {StaticStyles} from '../../shared/assets/styles/static'
import {useMediaQuery} from '../../shared/hooks/useMediaQuery'
import {useLayoutStore} from '../../shared/ui/layout'
import {Breadcrumbs} from '../../shared/ui/layout/ui/breadcrumbs'
import {Link} from '../../shared/ui/link'
import {cn, sanitizeHtml} from '../../shared/utils/functions'

import {Main, StaticHead, StaticMenu, StaticStyledContent} from './static.styles'
import {PageData} from '@/src/core/domain/entities/page/page-data'
import castArray from 'lodash/castArray'
import {useParams} from 'next/navigation'

export type StaticPageContent = {
  menu: LayoutMenuItem[]
  page: {title: string; html: string; show_title: boolean}
}

export const StaticScreenContent = observer((props: PageData<StaticPageContent>) => {
  const params = useParams()
  const layoutStore = useLayoutStore()

  const isMobile = useMediaQuery(`(max-width: ${theme.mediaSizes.md}px)`)

  const path = params.slug
    ? `/${decodeURIComponent((castArray(params.slug) ?? []).join('/'))}`
    : undefined

  const MenuContainer =
    props.content.menu.length > 0
      ? ({children}: React.PropsWithChildren) => (
          <div className="static-menu-container">{children}</div>
        )
      : ({children}: React.PropsWithChildren) => children
  return (
    <>
      <StaticStyles />
      <StaticHead className="main static">
        {props.content.page.title && (
          <div className="static-container static-container-title">
            <Breadcrumbs
              items={
                props.breadcrumbs.length > 0
                  ? props.breadcrumbs
                  : [{title: props.content.page.title}]
              }
            />

            {props.content.page.show_title && <h1>{props.content.page.title}</h1>}
          </div>
        )}
      </StaticHead>

      <Main className="main static">
        <MenuContainer>
          {props.content.menu.length > 0 && (
            <StaticMenu
              theme="dark"
              mode={isMobile ? 'horizontal' : 'vertical'}
              defaultSelectedKeys={(path && [path]) || undefined}
              items={props.content.menu
                .map(menuItem => ({
                  ...menuItem,
                  url: Routes.static(menuItem.url, layoutStore.data.static_pages ?? []),
                }))
                .map(menuItem => ({
                  label: <Link href={menuItem.url}>{menuItem.title}</Link>,
                  key: menuItem.url,
                  title: menuItem.title,
                  href: menuItem.url,
                }))}
            />
          )}
          <StaticStyledContent
            className={cn({
              'static-container': props.content.menu && props.content.menu.length > 0,
            })}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(props.content.page.html),
            }}
          />
        </MenuContainer>
      </Main>
    </>
  )
})
